module.exports = __webpack_public_path__ + "static/img/gzcb.dfc269d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/gzcb.png
// module id = N/DK
// module chunks = 93